import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerOptions,
  CapacitorBarcodeScannerScanResult,
  CapacitorBarcodeScannerTypeHintALLOption,
} from '@capacitor/barcode-scanner';
import { ScannerPluginWrapperBase } from './abstract-scanner-plugin-wrapper';
import { IBarcodeScannerPluginSetting } from './model';
import { Injectable } from '@angular/core';
import { Camera, PermissionStatus } from '@capacitor/camera';
import { ScanCancelledError } from './errors/scan-cancelled.error';

const SCAN_CANCELLED_ERROR_CODE = 'OS-PLUG-BARC-0006';

@Injectable()
export class CommunityScannerPluginWrapper extends ScannerPluginWrapperBase {
  startScan(options: IBarcodeScannerPluginSetting) {
    const scanOptions: CapacitorBarcodeScannerOptions = { hint: CapacitorBarcodeScannerTypeHintALLOption.ALL };
    CapacitorBarcodeScanner.scanBarcode(scanOptions)
      .then((value: CapacitorBarcodeScannerScanResult) => {
        if (!value.ScanResult) throw new Error('No content');
        this.onResult({ code: value.ScanResult });
      })
      .catch((error) => this.onError(this.mapError(error)));
    return Promise.resolve();
  }

  stopScan() {
    // TODO
    return Promise.resolve();
  }

  checkPermission(): Promise<boolean> {
    return Camera.requestPermissions({ permissions: ['camera'] }).then(
      (permissions: PermissionStatus) => (permissions.camera !== 'denied')
    );
  }

  private mapError(error: unknown): unknown {
    const code = (error as { code?: string })?.code;
    return code === SCAN_CANCELLED_ERROR_CODE ? new ScanCancelledError(error) : error;
  }
}
